// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LIST_OF_GROUPS_SHOW_MORE = "Uka\u017e v\u00edce";
export const LOAD_FEED_NEWEST = "P\u0159ejdi na nejnov\u011bj\u0161\u00ed p\u0159\u00edsp\u011bvky";
